/**
 * Control flow opcode handlers
 *
 * These handlers manage EVM execution flow: stopping, jumping, and returning.
 */

export { handler_0x5b_JUMPDEST } from "./0x5b_JUMPDEST.js";
export { handler_0x00_STOP } from "./0x00_STOP.js";
export { handler_0x56_JUMP } from "./0x56_JUMP.js";
export { handler_0x57_JUMPI } from "./0x57_JUMPI.js";
export { handler_0x58_PC } from "./0x58_PC.js";
export { handler_0xf3_RETURN } from "./0xf3_RETURN.js";
export { handler_0xfd_REVERT } from "./0xfd_REVERT.js";
